module.exports = __webpack_public_path__ + "static/media/15UN-Habitat14.b96e6616.jpg";